import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";
import InvoiceBadge from "./Badge";
import InvoiceItem from "./Item";

const Invoice = ({
  amount,
  generatedByName,
  generatedTimestamp,
  newExpiryTimestamp,
  paidTimestamp,
  sbid,
  vatRate,
}) => {
  return (
    <div className="flex select-none justify-between gap-6 rounded bg-white p-4 shadow-sm">
      <div className="flex flex-wrap gap-5">
        <InvoiceBadge isPaid={!!paidTimestamp} />
        <InvoiceItem className="w-[50px]" item="ID" value={sbid} />
        <InvoiceItem
          className="w-[100px]"
          item="Date generated"
          value={
            generatedTimestamp
              ? dayjs(generatedTimestamp * 1000).format("DD/MM/YYYY")
              : "-"
          }
        />
        <InvoiceItem className="w-[80px]" item="Amount" value={`£${amount}${vatRate && amount ? " + VAT" : ""}`} />
        <InvoiceItem
          className="w-[100px]"
          item="Date paid"
          value={
            paidTimestamp
              ? dayjs(paidTimestamp * 1000).format("DD/MM/YYYY")
              : "-"
          }
        />
        <InvoiceItem
          className="w-[100px]"
          item="New expiry"
          value={
            paidTimestamp
              ? dayjs(newExpiryTimestamp * 1000).format("DD/MM/YYYY")
              : "-"
          }
        />
        <InvoiceItem item="Generated by" value={generatedByName} />
      </div>
      <DownloadIcon
        className="my-auto cursor-pointer text-slate-600 transition hover:text-slate-800"
        onClick={() => (window.location = `/api/subscription/invoice/${sbid}`)}
      />
    </div>
  );
};

export default Invoice;
